import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ExternalReferenceService {
  readonly EXTERNAL_REFERENCE_QUERY_PARAM = 'externalReference';
  readonly EXTERNAL_REFERENCE_BODY_CLASS = 'si-external-reference';
  private _active: boolean | null = null; // null = not yet evaluated; boolean = cached result

  /**
   * Reads the "externalReference" query param from the URL.
   * Cached on first read so it stays stable for the whole session,
   * even if later navigation drops the query param.
   * This parameter is passed in from an external source when the app is embedded in an iframe
   */
  isActive(): boolean {
    if (this._active === null) {
      const queryParams = new URLSearchParams(window.location.search);
      this._active = queryParams.get(this.EXTERNAL_REFERENCE_QUERY_PARAM) === 'true';
    }

    return this._active;
  }

  /** Call once at app startup to add 'si-external-reference' on <body>. */
  initBodyClass(): void {
    if (this.isActive()) {
      document.body.classList.add(this.EXTERNAL_REFERENCE_BODY_CLASS);
    }
  }
}
